import { getPath } from '@/router/utils';
import {
  ROUTE_STOCKS_HOME,
  ROUTE_STOCKS_MARKET,
  ROUTE_STOCKS_MARKET_INDUSTRY,
} from '@/constants/routes';
import {
  DEFAULT_INDUSTRY,
  DEFAULT_MARKET,
  DEFAULT_SORT_BY,
} from '../constants';
import type { PrimaryCountryISOElseGlobal } from '@/constants/countries';
import type { SortBy } from '../hooks/useSortByOptions';

type GetStocksPath = {
  market: PrimaryCountryISOElseGlobal;
  industry?: string;
  sortBy?: SortBy;
  isLoggedIn: boolean;
};

const getPathType = (industry?: string) => {
  if (!industry || industry === DEFAULT_INDUSTRY) {
    return ROUTE_STOCKS_MARKET;
  }
  return ROUTE_STOCKS_MARKET_INDUSTRY;
};

export const isDefaultStocksPath = ({
  market,
  industry,
  sortBy,
}: Pick<GetStocksPath, 'market' | 'industry' | 'sortBy'>) =>
  market === DEFAULT_MARKET &&
  industry === DEFAULT_INDUSTRY &&
  sortBy === DEFAULT_SORT_BY;

export const getStocksPath = ({
  market,
  industry,
  sortBy,
  isLoggedIn,
}: GetStocksPath) => {
  if (
    isLoggedIn === false &&
    isDefaultStocksPath({ market, industry, sortBy })
  ) {
    // Logged out users get the /stocks route with default filters
    return getPath({ type: ROUTE_STOCKS_HOME, payload: {} });
  }
  return getPath({
    type: getPathType(industry),
    payload: { market, industry, sortBy },
  });
};

export const getStocksPathType = ({
  market,
  industry,
  sortBy,
  isLoggedIn,
}: GetStocksPath) => {
  if (
    isLoggedIn === false &&
    isDefaultStocksPath({ market, industry, sortBy })
  ) {
    return ROUTE_STOCKS_HOME;
  }
  return getPathType(industry);
};
